import { Icons } from "@/components/icons"
import { APP_ROUTES } from "@/constants/routes"

export interface NavItem {
  icon: (typeof Icons)[keyof typeof Icons]
  labelKey: string
  path: string
}

export const NAV_ITEMS: NavItem[] = [
  { icon: Icons.DashboardSquare02, labelKey: "nav.dashboard", path: APP_ROUTES.dashboard },
  { icon: Icons.PetrolPump, labelKey: "nav.gasAccount", path: APP_ROUTES.gasAccount },
  { icon: Icons.GoogleDoc, labelKey: "nav.policies", path: APP_ROUTES.policies },
  { icon: Icons.Advertisiment, labelKey: "nav.ads", path: APP_ROUTES.ads },
  { icon: Icons.AnalysisTextLink, labelKey: "nav.analytics", path: APP_ROUTES.analytics },
  { icon: Icons.Settings02, labelKey: "nav.settings", path: APP_ROUTES.settings },
]

/** Nav items shown in the bottom dock on mobile (Settings lives elsewhere, e.g. header). */
export const DOCK_NAV_ITEMS: NavItem[] = NAV_ITEMS.filter(
  (item) => item.path !== APP_ROUTES.settings
)
